export default "__VITE_ASSET__CakD6blS__"